class BaseModuleApp {

	// constructor
	constructor() {
		this.initCommonHandlers();
	}

	// init handlers
	initCommonHandlers() {
		// on scroll event
		window.addEventListener('scroll', event => {
			// body class list
			const bodyClassList = document.body.classList;

			// scrollTop offset
			let scrollTopOffset = 1;

			// get header
			// const header = document.querySelector('nav');
			// if(header !== undefined){
			//   scrollTopOffset = header.offsetHeight * 4;
			// }

			// set some classes to the top menu
			if (document.body.scrollTop > scrollTopOffset || document.documentElement.scrollTop > scrollTopOffset) {
				bodyClassList.add('scrolled');
				bodyClassList.remove('not-scrolled');
			} else {
				bodyClassList.add('not-scrolled');
				bodyClassList.remove('scrolled');
			}
		});

		// scroll to hash on page load
		if (window.location.hash) {
			this.scrollToHash(window.location.hash, 40);
		}

		// scroll to hash on the same page
		const currentUrl = window.location.href.replace(/#.*/, '');
		const hashLinks = document.querySelectorAll('a[href*="#"]');
		for (const hashLink of hashLinks) {
			// skip empty hash links
			if (hashLink.hash.trim() === '') {
				continue;
			}

			// get hash page url
			const hashPageUrl = hashLink.href.replace(/#.*/, '');

			// check is the same page
			if (currentUrl === hashPageUrl) {
				hashLink.addEventListener('click', this.clickOnHashLink.bind(this, hashLink));
			}
		}

		// register tooltips
		// $('body').tooltip({
		//   selector: '[data-toggle=tooltip]'
		// });

		// register search form show / hide
		const toggleSearchButton = document.querySelector('.show-search-form-wrapper-btn');
		if (toggleSearchButton !== null) {
			toggleSearchButton.addEventListener('click', this.toggleSearch.bind(this, toggleSearchButton));
		}

		// activate delete all checkbox button
		const deleteAllCheckboxButton = document.querySelector('input[type=checkbox][name="delete_all"]');
		if (deleteAllCheckboxButton !== null) {
			deleteAllCheckboxButton.addEventListener('change', this.showTopMenuDeleteBtn);
		}

		// show top menu delete button
		const deleteCheckboxButtons = document.querySelectorAll('input[type=checkbox][name="delete[]"]');
		for (const deleteCheckButton of deleteCheckboxButtons) {
			deleteCheckButton.addEventListener('change', this.showTopMenuDeleteBtn);
		}

		// kartik popoverX show
		const kvEditableItems = document.querySelectorAll('.kv-editable');
		for (const kvEditableItem of kvEditableItems) {
			kvEditableItem.classList.remove('d-none');
		}

		// auto size
		const textAreaInputs = document.querySelectorAll('textarea');
		for (const textAreaInput of textAreaInputs) {
			this.textAreaAutoSizeAssign(textAreaInput);
		}

		// card expanding
		const cardBodyExpandButtons = document.querySelectorAll('.card-body-expand-btn');
		for (const cardBodyExpandButton of cardBodyExpandButtons) {
			cardBodyExpandButton.addEventListener('click', this.toggleCardBody.bind(this, cardBodyExpandButton));
		}
	}

	// card expand
	toggleCardBody(button) {
		// settings
		const cardBodyIsVisible = parseInt(button.dataset.cardBodyIsVisible);
		const icon = button.querySelector('i');
		const card = button.closest('.card');
		const cardBody = card.querySelector('.card-body');

		// toggle
		if (cardBodyIsVisible === 1) {
			button.dataset.cardBodyIsVisible = 0;
			icon.classList.remove('fa-minus');
			icon.classList.add('fa-plus');
			cardBody.classList.add('d-none');
		} else {
			button.dataset.cardBodyIsVisible = 1;
			icon.classList.remove('fa-plus');
			icon.classList.add('fa-minus');
			cardBody.classList.remove('d-none');
		}
	}

	// click on hash link
	clickOnHashLink(hashLink, event) {
		event.preventDefault();

		// scroll to hash
		const hash = hashLink.hash;
		this.scrollToHash(hash);
	}

	// scroll to hash
	scrollToHash(hash, offset = 40) {
		const header = document.querySelector('header');
		const hashElement = document.querySelector(hash);
		if (header !== undefined && header !== null && hashElement !== undefined && hashElement !== null) {
			console.dir(hashElement);
			const topMenuHeight = header.clientHeight;
			$('html, body').stop().animate({
				scrollTop: $(hash).offset().top - topMenuHeight - offset,
			}, 500);
		}
	}

	// textarea autosize assign
	textAreaAutoSizeAssign(textAreaInput) {
		autosize(textAreaInput);
	}

	// toggle search
	toggleSearch(button) {
		// settings
		const active = parseInt(button.dataset.isActive);
		const label = button.querySelector('.btn-title');
		const searchFormWrapper = document.querySelector('.search-form-wrapper');

		// titles
		const titleIsCollapsed = button.dataset.titleIsCollapsed;
		const titleIsNotCollapsed = button.dataset.titleIsNotCollapsed;

		// switch
		if (active) {
			searchFormWrapper.classList.add('d-none');
			button.classList.remove('btn-danger');
			button.classList.add('btn-primary');
			button.dataset.isActive = 0;
			label.textContent = titleIsCollapsed;
		} else {
			searchFormWrapper.classList.remove('d-none');
			button.classList.remove('btn-primary');
			button.classList.add('btn-danger');
			button.dataset.isActive = 1;
			label.textContent = titleIsNotCollapsed;
		}
	}

	// show top menu delete btn
	showTopMenuDeleteBtn() {
		const checkboxes = document.querySelectorAll('input[type=checkbox][name="delete[]"]:checked');
		const topMenuDeleteBtn = document.querySelector('.top-menu-delete-btn');
		if (checkboxes.length > 0) {
			topMenuDeleteBtn.classList.remove('d-none');
		} else {
			topMenuDeleteBtn.classList.add('d-none');
		}

		// url for delete
		const hrefData = topMenuDeleteBtn.href.split('=');

		// ids
		const ids = [];

		// get all selected checkboxes
		for (const checkbox of checkboxes) {
			ids.push(checkbox.value);
		}

		// get ready url
		topMenuDeleteBtn.href = hrefData[0] + '=' + JSON.stringify(ids);
	}

	// show loader
	showLoader() {
		const loader = document.getElementById('bg-loader');
		if (loader !== null) {
			// use jquery fade in function
			$('#' + loader.id).fadeIn(500);
		}
	}

	// hide loader
	hideLoader() {
		const loader = document.getElementById('bg-loader');
		if (loader !== null) {
			// use jquery fade out function
			$('#' + loader.id).fadeOut(500);
		}
	}

	// hide tooltips
	hideTooltips() {
		const tooltips = document.querySelectorAll('.tooltip.show');
		for (const tooltip of tooltips) {
			tooltip.remove();
		}
	}

	// sign params with a csrf token
	getCsrfData() {
		return {
			param: this.getMetaTagValue('csrf-param'),
			token: this.getMetaTagValue('csrf-token'),
		};
	}

	// get csrf token
	getCsrfToken() {
		return this.getMetaTagValue('csrf-token');
	}

	// get meta tag value
	getMetaTagValue(metaTagName) {
		const metaTags = document.getElementsByTagName('meta');
		for (const metaTag of metaTags) {
			if (metaTag.getAttribute('name') === metaTagName) {
				return metaTag.getAttribute('content');
			}
		}

		// default output
		return null;
	}
}